module.exports = __webpack_public_path__ + "img/metamask-logo.c1f9de2e.png";